import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { formatNumberWithCommas } from "@/helpers/Helpers";
export default function UserPageFollowers(t0) {
  const $ = _c(13);
  const {
    handleOrWallet,
    followersCount
  } = t0;
  let t1;
  let t2;
  if ($[0] !== handleOrWallet) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const trimmedHandleOrWallet = handleOrWallet.trim();
      if (!trimmedHandleOrWallet) {
        t2 = null;
        break bb0;
      }
      t1 = trimmedHandleOrWallet.toLowerCase();
    }
    $[0] = handleOrWallet;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  const normalizedHandleOrWallet = t1;
  const safeHandleOrWallet = encodeURIComponent(normalizedHandleOrWallet);
  const count = followersCount ?? 0;
  const label = count === 1 ? "Follower" : "Followers";
  const t3 = `/${safeHandleOrWallet}/followers`;
  let t4;
  if ($[3] !== count) {
    t4 = formatNumberWithCommas(count);
    $[3] = count;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <span className="tw-text-base tw-font-semibold tw-text-iron-50">{t4}</span>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== label) {
    t6 = <span className="tw-block tw-text-base tw-font-medium tw-text-iron-400">{label}</span>;
    $[7] = label;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t5 || $[11] !== t6) {
    t7 = <Link href={t3} className="tw-no-underline tw-inline-flex tw-items-center tw-gap-x-1 desktop-hover:hover:tw-underline tw-transition tw-duration-300 tw-ease-out">{t5}{t6}</Link>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}